import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useStep } from '../spinner/useStep';
import { useValue } from './useValue';
import { useDraggable } from './useDraggable';
import { useStyles } from './useStyles';
import { useKeyboard } from './useKeyboard';
import { useClick } from './useClick';
import { usePoints } from './usePoints';
import { useMarks } from './useMarks';
import { useTooltip } from './useTooltip';
import { useConfigContext } from '../config';
var typeDefs = {
  max: Number,
  min: Number,
  value: [Number, Array],
  range: Boolean,
  unit: String,
  showEnd: Boolean,
  showInput: Boolean,
  step: [Number, Object, Function],
  points: [Array, Boolean],
  marks: Object,
  disabled: Boolean,
  showTooltip: Boolean,
  always: Boolean,
  animate: Boolean,
  tooltipProps: Object,
  spinnerProps: Object,
  forceStep: Boolean
};
var defaultStep = 1;
var defaults = function defaults() {
  return {
    max: 100,
    min: 0,
    value: 0,
    unit: '',
    showEnd: true,
    showInput: true,
    step: defaultStep,
    animate: true,
    forceStep: true
  };
};
var events = {
  change: true
};
export var Slider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Slider, _Component);
  function Slider() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.step = useStep(defaultStep);
    _this.value = useValue(_this.step, function () {
      return _this.draggable.dragging.value;
    });
    _this.tooltip = useTooltip(_this.value.showValue);
    _this.draggable = useDraggable(_this.value.showValue, _this.value.fixValue, _this.value.triggerChangeEvent, _this.tooltip.show);
    _this.styles = useStyles(_this.value.showValue);
    _this.keyboard = useKeyboard(_this.step, _this.draggable.getNewValue, _this.value.fixValue, _this.draggable.isFirst, _this.draggable.dragging, _this.value.triggerChangeEvent);
    _this.click = useClick(_this.draggable.getSlidingValue, _this.value.fixValue, _this.value.showValue, _this.value.setValue);
    _this.points = usePoints(_this.value.showValue, _this.step);
    _this.marks = useMarks();
    _this.config = useConfigContext();
    return _this;
  }
  return Slider;
}(Component);
Slider.template = template;
Slider.typeDefs = typeDefs;
Slider.defaults = defaults;
Slider.events = events;